export const environment = {
    host:'https://adminserv.etl.kidde-remotelync.com/api',
    login: 'login',
    logout: 'logout',
    self: 'self',
    password: 'password/change',
    user: 'user',
    location: 'location',
    device: 'device',
    deviceReports: 'device_reports',
    alert: 'alert',
    consent: 'consent',
    OTA: 'ota-job',
    upload: 'upload',
    iaqaas: 'iaqaas',
    subscriptions: 'subscription',
    history: 'history',
    defer: 'defer',
    external_redirect_urls: [
        'https://adminserv.etl.kidde-remotelync.com/release-notes/ai',
        'https://www.google.com/'
    ]
};